import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel, inputCls } from "@/components/Peep";
import { Link } from "react-router-dom";

export default function CreatorAccount() {
  const { user, startSession } = useAuth();
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const f = new FormData(form);
    const next = String(f.get("new_password") || "");
    if (next.length < 8) return toast.error("New password must be at least 8 characters.");
    if (next !== String(f.get("confirm") || "")) return toast.error("New passwords do not match.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: String(f.get("current_password") || ""), new_password: next });
      startSession(data);
      form.reset();
      toast.success("Password updated. Other devices have been signed out.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="creator-account" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Account settings</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">Signed in as <span data-testid="account-email" className="text-white">{user?.email}</span> · @{user?.username}</p>
      </div>
      <Panel title="Change password">
        <form onSubmit={submit} className="grid gap-2 md:max-w-md" noValidate>
          <input name="current_password" type="password" autoComplete="current-password" data-testid="account-current-password" placeholder="Current password" className={inputCls} />
          <input name="new_password" type="password" autoComplete="new-password" data-testid="account-new-password" placeholder="New password (8+ characters)" className={inputCls} />
          <input name="confirm" type="password" autoComplete="new-password" data-testid="account-confirm-password" placeholder="Confirm new password" className={inputCls} />
          <button disabled={busy} data-testid="account-password-save" className="btn-brand mt-1 flex items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold"><KeyRound size={15} /> {busy ? "Updating…" : "Update password"}</button>
        </form>
      </Panel>
      <p className="text-xs text-[#a7a0af]">Notification preferences live under <Link to="/creator/notifications" className="text-[#f0a8fa] underline">Notifications</Link>.</p>
      <p className="text-xs text-[#6f6878]">Need to change your login email or close your account? Contact the PEEPING administrator.</p>
    </div>
  );
}
